<template>
  <div
    class="overlay"
    @click="$emit('closeOverlay')"
  ></div>
</template>

<script>
  export default {
    name: 'SOverlay'
  }
</script>

<style lang="scss">
  .overlay {
    z-index: 990;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    visibility: hidden;
    background-color: transparent;
    transition: 0.2s;

    &--shown {
      opacity: 1;
      visibility: visible;
      background-color: rgba($primary, 0.65);
    }
  }
</style>